import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAreRVMjlfp-N_xOo7rlqIPzO5uECahmPY",
  authDomain: "playpro-1ea88.firebaseapp.com",
  projectId: "playpro-1ea88",
  storageBucket: "playpro-1ea88.firebasestorage.app",
  messagingSenderId: "860751152822",
  appId: "1:860751152822:web:analytics-dashboard",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

export default app;
